var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-register-nav"},[_c('Button',{staticClass:"logout",attrs:{"variant":"light","radius":""},on:{"click":_vm.logout}},[_vm._v("\n    ログアウト\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }